import { CompanyUser, Role } from '__generated__/GQL';

/**
 * Return whether the user will be shown the beneficiary flow.
 */
const getIsBeneficiary = (
  companyUser?: Pick<CompanyUser, 'roles' | 'isMandatee'>,
) => {
  // No company user means the company does not exist yet,
  // so the user can’t be an invitee.
  if (!companyUser) {
    return false;
  }

  // We don’t check for the presence of an invitation here as an AH
  // that was swapped to Invitee role afterwards wouldn’t have one
  return (
    !companyUser.roles.includes(Role.AccountHolder) && !companyUser.isMandatee
  );
};

export default getIsBeneficiary;
